var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dollar-icon_svg__a)",
    d: "M5.75 6.42c0-1.01-.62-1.67-1.86-2.05l-.29-.09V2.22c.46.19.8.56.98 1.08l1.14-.53A2.86 2.86 0 003.6.99V0h-.92v.91C1.23.97.25 1.83.25 3.07c0 .97.6 1.7 1.84 2.08l.59.18v2.06a2.12 2.12 0 01-1.54-1.38L0 6.53a3.08 3.08 0 002.68 2.05v.9h.92v-.91c1.31-.17 2.15-.99 2.15-2.15zM2.46 3.93c-.56-.17-.87-.49-.87-.92 0-.5.43-.87 1.09-.92V4l-.22-.07zM3.6 7.37V5.62c.52.17.81.43.81.89 0 .4-.3.73-.81.86z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dollar-icon_svg__a",
    x1: 5.75,
    x2: -2.67,
    y1: 0,
    y2: 4.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71F4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB4B"
  })))));
}

export default SvgDollarIcon;